import { Component, OnInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { FaqsService } from '../faqs.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {
  faqForm: DVFormGroup;
  isAddState = true;
  groups: Array<any>;
  constructor(
    private faqsApi: FaqsService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    if (this.route.snapshot.params[`id`]) {
      this.isAddState = false;
      this.faqsApi.getFaqById(this.route.snapshot.params.id).subscribe((Response)=>{
        this.faqForm.patchValue(Response.data.faq);
      });
    } else {
      this.isAddState = true;
    }
    this.faqsApi.getGroupFaq().subscribe(Response => {
      // console.log(Response);
      this.groups = Response.data.faqGroups;
    });
    this.faqForm = new DVFormGroup({
      question: new DVFormControl(null, {
        'Question  is required': Validators.required
      }),
      answer: new DVFormControl(null, {
        'Answer Title is required': Validators.required
      }),
      groupId: new DVFormControl(null, {
        'Group Description is required': Validators.required
      })
    });
  }

  ngOnInit() {}
  SubmitForm() {
    if (this.faqForm.valid) {
      this.faqsApi.addFaq(this.faqForm.value).subscribe(Response => {
        // console.log(Response);
        this.notifier.success('FAQ Has Added Successfully');
        this.router.navigateByUrl('/settings/faqs/list');
        this.faqForm.reset();
      });
    } else {
      this.faqForm.forceShowErrors();
    }
  }
  EditForm() {
    if (this.faqForm.valid) {
    this.faqsApi.editFaq(this.faqForm.value, this.route.snapshot.params.id).subscribe((Response) => {
      console.log(Response);
      this.notifier.success('FAQ Edited Successfully');
      this.router.navigateByUrl('/faq-list');
    }, err => {
      this.notifier.error(err.error.userMessage);
    });
   } else {
    this.faqForm.forceShowErrors();
  }
  }
  CancelForm() {
    this.router.navigateByUrl('/settings/faqs/add');
  }
}
